/*
  F04 web_item_docs: the item page, the forms, the symbol picker, the documents, the library browser, the files view,
  the chapter editor, the project code lists and the open points (BUILD-PLAN 2.11.2). F01's router collects the
  routes.tsx of every feature folder with import.meta.glob.
*/

import type { RouteObject } from "react-router-dom";

import { AddByHandPage } from "./pages/AddByHandPage";
import { ChapterPage } from "./pages/ChapterPage";
import { DeliverablePage } from "./pages/DeliverablePage";
import { EditElementPage } from "./pages/EditElementPage";
import { ElementPage } from "./pages/ElementPage";
import { FilesPage } from "./pages/FilesPage";
import { ItemPage } from "./pages/ItemPage";
import { LibraryPage } from "./pages/LibraryPage";
import { OpenPointsPage } from "./pages/OpenPointsPage";
import { ProjectListsPage } from "./pages/ProjectListsPage";
import { SymbolsPage } from "./pages/SymbolsPage";
import { UploadPage } from "./pages/UploadPage";
import "./item.css";

export const routes: RouteObject[] = [
  { path: "/items/:id", element: <ItemPage /> },
  { path: "/elements/new", element: <AddByHandPage /> },
  { path: "/elements/:id", element: <ElementPage /> },
  { path: "/elements/:id/edit", element: <EditElementPage /> },
  { path: "/symbols", element: <SymbolsPage /> },
  { path: "/deliverables/new", element: <UploadPage /> },
  { path: "/deliverables/:id", element: <DeliverablePage /> },
  { path: "/library", element: <LibraryPage /> },
  { path: "/files", element: <FilesPage /> },
  { path: "/chapters/:key", element: <ChapterPage /> },
  { path: "/project-lists", element: <ProjectListsPage /> },
  { path: "/open-points", element: <OpenPointsPage /> },
];
